import { ActionContext, MutationTree } from 'vuex'
import { getUserInfo, getRoomInfo } from '@/api/user'
const state = () => ({
  userInfo: {
    isLogin: false,
    uid: 0,
    uname: '',
    face: '',
    room_id: 0,
  },
})

export type userState = ReturnType<typeof state>

const mutations: MutationTree<userState> = {
  /**
   * @desc 设置用户信息
   * @param state
   * @param user
   * @constructor
   */
  SET_USER_INFO: (state: userState, user: any) => {
    const { isLogin, mid, uname, face } = user.result
    const { room_id } = user.roomres
    state.userInfo = { isLogin, uid: mid, uname, face, room_id }
  },
}

const actions = {
  async setUserInfo(ctx: ActionContext<userState, unknown>) {
    try {
      const result = await getUserInfo()
      const roomres = await getRoomInfo()
      const res = { result, roomres }
      ctx.commit('SET_USER_INFO', res)
    } catch (e) {
      console.log(e)
    }
  },
}

// getters
const getters = {}

export default {
  // 开启命名空间
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
